export const experienceData = [
  {
    id: 1,
    company: "Cherry Byte Technologies",
    jobtitle: "Full Stack Developer",
    startYear: "31/07/2024",
    endYear: "Present",
  },
  {
    id: 2,
    company: "CreativeLogicx",
    jobtitle: "Software Engineer",
    startYear: "24/04/2024",
    endYear: "01/07/2024",
  },
  {
    id: 3,
    company: "Axcel",
    jobtitle: "Associate Software Engineer",
    startYear: "10/08/2023",
    endYear: "20/03/2024",
  },
  {
    id: 4,
    company: "MicroTech IT Solutions",
    jobtitle: "MERN Stack Developer (Internship)",
    startYear: "04/09/2022",
    endYear: "12/03/2023",
  },
];
